import { combineReducers } from 'redux';
import auth from '../feature/auth';
import { default as common } from '../feature/common';
import facility from '../feature/facility';
import caseReports from '../feature/case-reports';
import eventListener from '../feature/eventListener';

export default combineReducers({
  auth,
  common,
  facility,
  caseReports,
  eventListener,
});
